import { useState, useEffect } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
    IconButton,
    Grid,
    Box
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";

import LoginForm from "../forms/LoginForm";
import { useLoginUser } from "../../hooks/authHooks";
import GoogleLogin from "./GoogleLogin";

// import {usePingService} from "../../hooks/dataHooks";


const LoginPopup = ({ onClose, onRegister, onForgotPassword }) => {
    // const navigate = useNavigate();

    const { mutate: loginUser, isPending: isLoggingIn, error: loginError, data: loginData } = useLoginUser();
    const [errorMessage, setErrorMessage] = useState("");

    // const {mutate: pingService} = usePingService();
    // useState(() => {
    //     pingService();
    // }, [pingService])


    const handleLogin = (values) => {
        const formData = {
            email: values.email,
            password: values.password,
        };

        loginUser(formData);
    };

    useEffect(() => {
        if (loginData) {

            setErrorMessage("");
            onClose();
            // navigate("/");
            // Navigate and reload
            window.location.replace("/");
        }
    }, [loginData, onClose,
        // navigate
    ]);

    useEffect(() => {
        if (loginError) {
            setErrorMessage("Invalid credentials. Please try again.");
        }
    }, [loginError]);

    return (
        <Dialog open={true} maxWidth="sm" >
            <Grid container
            // spacing={2}
            >
                {/* Left Side - Login Form */}
                {false &&

                    <Grid item xs={12} sm={6}>
                        <DialogTitle>
                            Login
                            <IconButton
                                aria-label="close"
                                onClick={onClose}
                                sx={{
                                    position: "absolute",
                                    right: 8,
                                    top: 8,
                                    color: (theme) => theme.palette.grey[500],
                                }}
                            >
                                <CloseOutlined sx={{ color: (theme) => theme.palette.grey[500] }} />
                            </IconButton>
                        </DialogTitle>

                        {errorMessage && (
                            <DialogContent>
                                <Typography variant="body1" color="error">{errorMessage}</Typography>
                            </DialogContent>
                        )}

                        <DialogContent>
                            <LoginForm isLoggingIn={isLoggingIn} onRegister={onRegister} onSubmit={handleLogin} onClose={onClose} onForgotPassword={onForgotPassword} />
                        </DialogContent>
                    </Grid>
                }
                {/* Right Side - Google Login */}
                <Grid item xs={12} sm={12}>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseOutlined sx={{ color: (theme) => theme.palette.grey[500] }} />
                    </IconButton>
                    <Box>
                        {/* Or Login with Google */}
                        <GoogleLogin onClose={onClose} />
                    </Box>
                </Grid>
            </Grid>
        </Dialog>
    );

};


export default LoginPopup;